export default __webpack_public_path__ + "static/alexanderShpilka-bce7319dc03e0afd30aa74dbfc65cd74.png";